/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Unlock_Plus_CnaInputs */

const en_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const ar_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const de_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const es_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const fr_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const it_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const ja_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const ko_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const pt_br_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const ru_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const th_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const tr_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Plus Membership`)
};

const zh_cn_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开通 Plus 会员`)
};

const zh_tw_btn_unlock_plus_cna = /** @type {(inputs: Btn_Unlock_Plus_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开通 Plus 会员`)
};

/**
* | output |
* | --- |
* | "Get Plus Membership" |
*
* @param {Btn_Unlock_Plus_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_unlock_plus_cna = /** @type {((inputs?: Btn_Unlock_Plus_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Unlock_Plus_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_unlock_plus_cna(inputs)
	if (locale === "ar") return ar_btn_unlock_plus_cna(inputs)
	if (locale === "de") return de_btn_unlock_plus_cna(inputs)
	if (locale === "es") return es_btn_unlock_plus_cna(inputs)
	if (locale === "fr") return fr_btn_unlock_plus_cna(inputs)
	if (locale === "it") return it_btn_unlock_plus_cna(inputs)
	if (locale === "ja") return ja_btn_unlock_plus_cna(inputs)
	if (locale === "ko") return ko_btn_unlock_plus_cna(inputs)
	if (locale === "pt_br") return pt_br_btn_unlock_plus_cna(inputs)
	if (locale === "ru") return ru_btn_unlock_plus_cna(inputs)
	if (locale === "th") return th_btn_unlock_plus_cna(inputs)
	if (locale === "tr") return tr_btn_unlock_plus_cna(inputs)
	if (locale === "zh_cn") return zh_cn_btn_unlock_plus_cna(inputs)
	return zh_tw_btn_unlock_plus_cna(inputs)
});